import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Col, Grid, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import './UserInvitations.css';
import plusIconPng from '../../../images/plus-icon.png';
import AddInvitation from './AddInvitation';
import ShowInvitation from './ShowInvitation';

export const InvitationPropTypes = {
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  email: PropTypes.string,
  permissions: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      label: PropTypes.string,
      selected: PropTypes.bool,
    })
  ),
  title: PropTypes.string,
};

class UserInvitations extends Component {
  static propTypes = {
    invitations: PropTypes.arrayOf(PropTypes.shape(InvitationPropTypes)),
    currentInvitation: PropTypes.shape(InvitationPropTypes),
    onAdd: PropTypes.func,
    onSent: PropTypes.func,
    onCurrentInvitationChange: PropTypes.func,
    onRemove: PropTypes.func,
  };

  constructor() {
    super();
    this.state = {
      addEnable: false,
    };
  }

  handleInvitationRemove = (id) => {
    this.props.onRemove(id);
  };

  handleAddUser = () => {
    if (this.state.addEnable) {
      this.props.onAdd({
        firstName: this.props.currentInvitation.firstName,
        lastName: this.props.currentInvitation.lastName,
        email: this.props.currentInvitation.email,
        permissions: this.props.currentInvitation.permissions,
        title: this.props.currentInvitation.title,
      });

      this.setState({
        addEnable: false,
      });
    }
  };

  handleAddInvitationChange = (newState) => {
    let addEnable =
      newState.firstName !== '' &&
      newState.lastName !== '' &&
      newState.email !== '' &&
      newState.permissions.filter((element) => {
        return element.selected;
      }).length > 0;

    this.setState({
      addEnable: addEnable,
    });

    this.props.onCurrentInvitationChange(newState);
  };

  handleSentInvitations = () => {
    if (this.props.invitations.length > 0) {
      this.props.onSent();
    }
  };

  render() {
    return (
      <div className="user-invitations client">
        <Grid>
          <Row>
            <Col lg={6} lgOffset={3}>
              <div className="title">
                <span>Invite Users</span>
              </div>
            </Col>
          </Row>

          <Row>
            <Col lg={6} lgOffset={3}>
              <div className="subtitle">
                <span>
                  Users will be emailed an invite to finish creating their
                  account.
                </span>
              </div>
            </Col>
          </Row>

          <Row>
            <Col lg={10} lgOffset={1}>
              {this.props.invitations.map((invitation) => (
                <ShowInvitation
                  user={invitation}
                  onDelete={this.handleInvitationRemove}
                  key={invitation.id}
                />
              ))}
            </Col>
          </Row>

          <Row>
            <Col lg={10} lgOffset={1}>
              <AddInvitation
                invitation={this.props.currentInvitation}
                onChange={this.handleAddInvitationChange}
              />
            </Col>
          </Row>

          <Row>
            <Col lg={6} lgOffset={3}>
              <div className="button-container">
                <button
                  id="add-user"
                  className={
                    'btn btn-select btn-gray' +
                    (this.state.addEnable ? '' : ' disabled')
                  }
                  onClick={this.handleAddUser}
                >
                  <img src={plusIconPng} alt="plus" /> Add aditional user
                </button>
              </div>
            </Col>
          </Row>

          <Row>
            <Col lg={6} lgOffset={3}>
              <div className="button-container">
                <button
                  id="invite-users"
                  className={
                    'btn btn-select btn-orange' +
                    (this.props.invitations.length === 0 ? ' disabled' : '')
                  }
                  onClick={this.handleSentInvitations}
                >
                  Invite Users
                </button>
              </div>
            </Col>
          </Row>

          <Row>
            <Col lg={6} lgOffset={3}>
              <div className="bottom-title">
                <span>
                  <Link to="/">I&#39;ll do it later</Link>
                </span>
              </div>
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

export default UserInvitations;



// WEBPACK FOOTER //
// ./src/components/client/user-invitations/UserInvitations.js